/**
 * 繁體中文語言包
 */

export default {
  // 通用
  common: {
    ok: '確定',
    cancel: '取消',
    confirm: '確認',
    delete: '刪除',
    edit: '編輯',
    add: '新增',
    save: '儲存',
    reset: '重置',
    search: '搜尋',
    clear: '清除',
    refresh: '重新整理',
    export: '匯出',
    import: '匯入',
    upload: '上傳',
    download: '下載',
    view: '檢視',
    detail: '詳情',
    back: '返回',
    submit: '提交',
    close: '關閉',
    loading: '載入中...',
    noData: '暫無資料',
    total: '共',
    items: '條',
    page: '頁',
    go: '跳轉',
    success: '成功',
    error: '錯誤',
    warning: '警告',
    info: '資訊',
    yes: '是',
    no: '否',
    enable: '啟用',
    disable: '停用',
    statusLabel: '狀態',
    action: '操作',
    actions: '操作',
    createTime: '建立時間',
    updateTime: '更新時間',
    remark: '備註',
    sort: '排序',
    more: '更多',
    expand: '展開',
    collapse: '收起',
    of: '共',
    enterprise: '企業',
    user: '使用者',
    settings: '設定',
    // 狀態值
    status: {
      active: '啟用',
      inactive: '停用',
      archived: '已歸檔',
    },
  },

  // 異常頁面
  exception: {
    notFound: '抱歉，您訪問的頁面不存在。',
    forbidden: '抱歉，您沒有權限訪問此頁面。',
    serverError: '抱歉，伺服器發生錯誤。',
    backHome: '返回首頁',
    backPrevious: '返回上頁',
    refresh: '重新整理頁面',
  },

  // 表格
  table: {
    columnSettings: '欄位設定',
    selectAll: '全選',
    columnSettingsTip: '拖曳調整欄位順序，點擊核取方塊顯示/隱藏欄位',
  },

  // 表單擴展
  form: {
    required: '此欄位為必填項',
    email: '請輸入有效的電子郵件地址',
    phone: '請輸入有效的手機號碼',
    password: '密碼長度應在6-20位之間',
    confirmPassword: '兩次輸入的密碼不一致',
    username: '使用者名稱長度應在3-20位之間',
    select: '請選擇',
    input: '請輸入',
    upload: '請上傳檔案',
    date: '請選擇日期',
    time: '請選擇時間',
    number: '請輸入數字',
    url: '請輸入有效的URL地址',
    idCard: '請輸入有效的身分證號碼',
    bankCard: '請輸入有效的銀行卡號',
    zipCode: '請輸入有效的郵遞區號',
    startDate: '開始日期',
    endDate: '結束日期',
  },

  // 選單
  menu: {
    home: '首頁',
    dashboard: '儀表板',
    workplace: '工作台',
    analysis: '分析頁',
    monitor: '監控頁',

    product: '商品管理',
    productList: '商品列表',
    productAdd: '新增商品',
    productEdit: '編輯商品',
    productCategory: '商品分類',
    categoryList: '分類管理',
    productBrand: '品牌管理',
    brandList: '品牌管理',
    labelList: '標籤管理',
    templateList: '模板管理',
    productUnit: '計量單位',
    productSku: 'SKU管理',
    skuList: 'SKU列表',
    moqTemplateList: '起售模板',
    categoryShipmentTemplateList: '大類起運模版',
    priceMonitor: '價格監控',
    productConfig: '商品配置',
    businessOrder: '業務訂單',

    inventory: '庫存管理',
    inventoryList: '庫存列表',
    inventoryInbound: '入庫管理',
    inventoryOutbound: '出庫管理',
    inventoryTransfer: '庫存調撥',
    inventoryCheck: '庫存盤點',

    order: '訂單管理',
    orderList: '訂單列表',
    orderDetail: '訂單詳情',
    orderRefund: '退款管理',
    orderAfterSale: '售後管理',
    salesOrder: '銷售訂單',
    pendingApproval: '待審批訂單',
    purchaseOrder: '採購單',
    returnOrder: '退貨單',
    purchaseAfterSales: '採購售後單',
    salesAfterSales: '銷售售後單',
    paymentRecord: '付款記錄',
    orderStatistics: '訂單統計',
    cart: '購物車',

    customer: '客戶管理',
    customerList: '客戶列表',
    customerGroup: '客戶分組',
    customerLevel: '客戶等級',
    customerLevels: '客戶等級',
    levelPrices: '等級價格',
    salesmen: '銷售員管理',
    customerInfo: '客戶資訊',
    customerType: '客戶類型',

    finance: '財務管理',
    financeAccount: '帳戶管理',
    financeFlow: '資金流水',
    financeStatement: '財務報表',

    marketing: '行銷管理',
    marketingCoupon: '優惠券',
    marketingPromotion: '促銷活動',
    marketingMember: '會員管理',

    content: '內容管理',
    contentArticle: '文章管理',
    contentBanner: '輪播圖',
    contentNotice: '公告管理',

    system: '系統管理',
    systemUser: '使用者管理',
    systemRole: '角色管理',
    systemPermission: '權限管理',
    systemDept: '部門管理',
    systemDict: '字典管理',
    systemConfig: '系統配置',
    systemLog: '操作日誌',
    systemMenu: '菜單管理',

    personal: '個人中心',
    personalInfo: '個人資訊',
    personalPassword: '修改密碼',
    personalSetting: '個人設定',

    // 管理模式
    adminMode: '管理模式',
    businessMode: '業務模式',
    adminDashboard: '管理概覽',
    tenantSettings: '租戶設定',
    openapiApps: '對外接口管理',
    organization: '組織管理',
    tenantManagement: '租戶管理',
    subTenantManagement: '子租戶管理',
    organizationManagement: '組織管理',
    memberManagement: '成員管理',
    themeConfig: '主題配置',

    // 管理模式 - 職能域分組
    orgPeople: '組織人員',
    systemOrganization: '組織架構',
    systemUsers: '使用者管理',
    systemPosition: '崗位管理',
    accessControl: '存取控制',
    systemRoles: '角色管理',
    systemPermissions: '權限資源',
    systemMenus: '選單管理',
    systemDataScope: '資料範圍',
    systemFieldPermission: '欄位權限',
    securityAudit: '安全稽核',
    permissionOverride: '權限覆蓋',
    permissionTracing: '權限溯源',
    permissionAudit: '權限稽核',
    loginLog: '登入日誌',
    auditLog: '稽核日誌',
    messageCenter: '訊息中心',
    subscription: '我的訂閱',
    adminOrders: '訂單記錄',
    invoices: '發票管理',
    mallDecoration: '商城裝修',

    // 業務模組
    distributionManagement: '分銷管理',
    productAssign: '商品鋪貨',
    pricingStrategies: '定價策略',
    networkTopology: '網路拓撲',
    tradeManagement: '交易管理',
    tradeQuotes: '客戶報價',
    tradeOrders: '客戶訂單',
    tradeCommission: '佣金結算',
    warehouseManagement: '倉庫管理',
    warehouse: '倉庫管理',
    warehousePermissions: '倉庫授權',
    warehouseReceipt: '入庫單',
    warehouseList: '倉庫列表',
    inventoryMgmt: '庫存管理',
    inboundManagement: '入庫管理',
    outboundManagement: '出庫管理',
    stocktakeManagement: '盤點管理',
    settlementManagement: '結算管理',
    settlementList: '結算列表',
    creditLine: '授信額度',
    settlementRule: '結算規則',
    reportCenter: '報表中心',
    salesReport: '銷售報表',
    inventoryReport: '庫存報表',
    financeReport: '財務報表',
    financeInvoices: '發票管理',
    financeManagement: '財務管理',
    settlementBills: '結算單',
    accounts: '帳戶管理',
    financeReceipts: '收款單',
    financeDisbursements: '付款單',
    financeFundAccounts: '資金賬戶',
    logisticsManagement: '物流管理',
    shippingCarriers: '快遞公司',
    shipments: '發貨記錄',
    logisticsTracking: '物流追蹤',
    carrierPermissions: '快遞權限配置',
    promotionManagement: '推廣管理',
    promotionProjects: '推廣項目',
    promotionCoupon: '優惠券',
    draftOrders: '草稿單管理',
    channel: '渠道管理',
    channelShops: '網店管理',
    channelList: '渠道列表',
    cargoManagement: '貨盤管理',
    cargoLots: '貨盤列表',
    cargoAllocations: '貨盤分配',
    cargoDistributors: '分銷商管理',
    cargoProducts: '商品鋪貨',
    cargoPricing: '定價策略',
    ycodeManagement: 'Y碼管理',
    ycodelist: 'Y碼列表',
    ycodeRedemptions: '核銷記錄',
    ycodePrices: '價格配置',
    productWhitelist: '產品白名單',
    productBundles: '組合方案',
  },

  // 頁面標題
  title: {
    dashboard: '儀表板',
    login: '登入',
    register: '註冊',
    forgotPassword: '忘記密碼',
    resetPassword: '重設密碼',
    profile: '個人資料',
    settings: '系統設定',
    notFound: '頁面不存在',
    serverError: '伺服器錯誤',
    unauthorized: '未授權',
    forbidden: '禁止訪問',
  },

  // 操作提示
  message: {
    loginSuccess: '登入成功',
    loginFailed: '登入失敗',
    logoutSuccess: '登出成功',
    saveSuccess: '儲存成功',
    saveFailed: '儲存失敗',
    deleteSuccess: '刪除成功',
    deleteFailed: '刪除失敗',
    deleteConfirm: '確定要刪除嗎？',
    updateSuccess: '更新成功',
    updateFailed: '更新失敗',
    uploadSuccess: '上傳成功',
    uploadFailed: '上傳失敗',
    exportSuccess: '匯出成功',
    exportFailed: '匯出失敗',
    importSuccess: '匯入成功',
    importFailed: '匯入失敗',
    copySuccess: '複製成功',
    copyFailed: '複製失敗',
    networkError: '網路錯誤',
    serverError: '伺服器錯誤',
    paramError: '參數錯誤',
    permissionDenied: '權限不足',
    operationSuccess: '操作成功',
    operationFailed: '操作失敗',
    noChanges: '沒有變更',
  },

  // 頭部導航
  header: {
    profile: '個人資料',
    settings: '設定',
    guide: '操作手冊',
    logout: '登出',
    notifications: '通知',
    allNotifications: '查看全部通知',
    search: '搜尋',
    help: '幫助',
    support: '支援',
    language: '語言',
    theme: '主題',
  },

  // 登入頁面
  login: {
    title: 'Coolbuy 3.0',
    subtitle: '企業級 PaaS 管理平台',
    username: '使用者名稱',
    password: '密碼',
    remember: '記住登入狀態',
    forgot: '忘記密碼？',
    login: '登入',
    register: '註冊帳號',
    thirdParty: '第三方登入',
    usernameRequired: '請輸入使用者名稱',
    passwordRequired: '請輸入密碼',
    loginSuccess: '登入成功',
    loginFailed: '使用者名稱或密碼錯誤',
    usernameLabel: '使用者名稱',
    usernamePlaceholder: '請輸入使用者名稱',
    passwordLabel: '密碼',
    passwordPlaceholder: '請輸入密碼',
    captcha: '驗證碼',
    captchaLabel: '驗證碼',
    captchaPlaceholder: '請輸入驗證碼',
    captchaRequired: '請輸入驗證碼',
    captchaInvalid: '請輸入正確的驗證碼',
    captchaError: '獲取驗證碼失敗',
    getCaptcha: '獲取驗證碼',
    quickLogin: '快速登入',
    quickLoginSuccess: '快速登入成功',
    quickLoginFailed: '快速登入失敗',
    success: '登入成功',
    failed: '登入失敗',
    welcomeBack: '歡迎回來！',
    errorMessage: '使用者名稱或密碼錯誤，請重試',
  },

  // 設定
  settings: {
    title: '系統設定',
    language: '語言',
    theme: '主題',
    layout: '版面配置',
    navigation: '導航',
    content: '內容區域',
    footer: '頁尾',
    other: '其他設定',

    lightTheme: '淺色主題',
    darkTheme: '深色主題',
    autoTheme: '跟隨系統',

    sideLayout: '側邊版面',
    topLayout: '頂部版面',
    mixLayout: '混合版面',

    fixedHeader: '固定頭部',
    fixedSidebar: '固定側邊欄',
    showTabs: '顯示標籤頁',
    showBreadcrumb: '顯示麵包屑',
    showFooter: '顯示頁尾',

    compactMode: '緊湊模式',
    weakMode: '色弱模式',
    colorBlind: '色盲模式',

    reset: '恢復預設',
    resetConfirm: '確定要恢復預設設定嗎？',
  },

  // 工作台
  workplace: {
    welcome: '早安，{{name}}，祝你開心每一天！',
    welcomeSystem: '歡迎使用系統，今日',
    quickNav: '快捷導航',
    recentVisit: '最近訪問',
    myProject: '我的專案',
    quickEntry: '快速入口',
    announcement: '通知公告',
    todoList: '待辦事項',
    workProgress: '工作進度',
    teamActivity: '團隊動態',
    refreshData: '重新整理',

    todayData: '今日資料',
    totalUsers: '總使用者數',
    totalOrders: '總訂單數',
    totalRevenue: '總營收',
    newUsers: '新增使用者',
    newOrders: '新增訂單',
    todayRevenue: '今日營收',

    // 即時資料
    realTimeData: '今日即時資料',
    realTime: '即時',
    todayOrderCount: '今日訂單',
    todaySalesAmount: '今日銷售額',
    onlineUsers: '線上使用者',
    conversionRate: '轉換率',

    // 系統狀態
    systemStatus: '系統狀態',
    normal: '正常',
    cpuUsage: 'CPU使用率',
    memoryUsage: '記憶體使用率',
    diskUsage: '磁碟使用率',
    performanceIndex: '效能指標',

    // 圖表
    salesTrend: '銷售額趨勢',
    regionSales: '銷售地區分佈',
    categorySales: '產品分類銷量',
    salesAndOrders: '銷售額與訂單量',

    chart: {
      orderTrend: '訂單趨勢',
      userGrowth: '使用者成長',
      revenueTrend: '營收趨勢',
      categoryDistribution: '品類分佈',
      regionDistribution: '地區分佈',
      last30Days: '最近30天',
    },
  },

  // 商品相關
  product: {
    title: '商品管理',
    name: '商品名稱',
    code: '商品編碼',
    category: '商品分類',
    brand: '品牌',
    price: '價格',
    costPrice: '成本價',
    retailPrice: '零售價',
    wholesalePrice: '批發價',
    stock: '庫存',
    unit: '單位',
    spec: '規格',
    barcode: '條碼',
    description: '商品描述',
    image: '商品圖片',
    status: '狀態',
    onSale: '上架',
    offSale: '下架',
    createProduct: '新增商品',
    editProduct: '編輯商品',
    viewProduct: '檢視商品',
    deleteProduct: '刪除商品',
    batchImport: '批量匯入',
    batchExport: '批量匯出',
  },

  // 訂單相關
  order: {
    title: '訂單管理',
    orderNo: '訂單編號',
    orderType: '訂單類型',
    orderStatus: '訂單狀態',
    orderAmount: '訂單金額',
    payAmount: '付款金額',
    payStatus: '付款狀態',
    payTime: '付款時間',
    customer: '客戶',
    receiver: '收貨人',
    receiverPhone: '收貨電話',
    receiverAddress: '收貨地址',
    deliveryStatus: '發貨狀態',
    deliveryTime: '發貨時間',
    expressNo: '快遞單號',
    remark: '備註',
    createOrder: '建立訂單',
    viewOrder: '檢視訂單',
    cancelOrder: '取消訂單',
    confirmOrder: '確認訂單',
    shipOrder: '發貨',
    completeOrder: '完成訂單',
    refund: '退款',
    afterSale: '售後',
    pending: '待付款',
    paid: '已付款',
    shipped: '已發貨',
    completed: '已完成',
    cancelled: '已取消',
  },

  // 客戶相關
  customer: {
    title: '客戶管理',
    name: '客戶名稱',
    code: '客戶編碼',
    type: '客戶類型',
    level: '客戶等級',
    contact: '聯絡人',
    phone: '聯絡電話',
    email: '電子郵件',
    address: '地址',
    creditLimit: '授信額度',
    balance: '餘額',
    points: '積分',
    createCustomer: '新增客戶',
    editCustomer: '編輯客戶',
    viewCustomer: '檢視客戶',
    deleteCustomer: '刪除客戶',
  },

  // 庫存相關
  inventory: {
    title: '庫存管理',
    warehouse: '倉庫',
    location: '庫位',
    quantity: '數量',
    availableQty: '可用數量',
    lockedQty: '鎖定數量',
    inbound: '入庫',
    outbound: '出庫',
    transfer: '調撥',
    stocktaking: '盤點',
    inboundNo: '入庫單號',
    outboundNo: '出庫單號',
    transferNo: '調撥單號',
    createInbound: '建立入庫單',
    createOutbound: '建立出庫單',
    createTransfer: '建立調撥單',
  },

  // 財務相關
  finance: {
    title: '財務管理',
    account: '帳戶',
    balance: '餘額',
    income: '收入',
    expense: '支出',
    transaction: '交易',
    transactionNo: '交易單號',
    transactionType: '交易類型',
    transactionAmount: '交易金額',
    transactionTime: '交易時間',
    receipt: '收款',
    payment: '付款',
    statement: '對帳單',
    invoice: '發票',
  },

  // 分類
  category: {
    electronics: '電子產品',
    clothing: '服裝',
    books: '圖書',
    home: '家居',
  },

  // 狀態
  status: {
    active: '啟用',
    inactive: '停用',
    pending: '待審核',
    approved: '已審核',
    rejected: '已拒絕',
  },

  // 帳戶設定
  account: {
    settings: '帳號設定',
    security: '安全設定',
    notification: '通知偏好',
    personalization: '個人化',
    binding: '帳號綁定',
    changePassword: '修改密碼',
    twoFactorAuth: '兩步驗證',
    loginDevices: '登入裝置',
    loginLog: '登入日誌',
    bindPhone: '綁定手機',
    bindEmail: '綁定電子郵件',
    bindWechat: '綁定微信',
    bindWecom: '綁定企業微信',
    unbind: '解除綁定',
    bound: '已綁定',
    unbound: '未綁定',
    securityLevel: '安全等級',
    securityTips: '安全提示',
  },

  // 個人中心
  profile: {
    title: '個人中心',
    messageCenter: '訊息中心',
    myWorkspace: '我的工作台',
    basicInfo: '基本資訊',
    avatar: '頭像',
    nickname: '暱稱',
    email: '電子郵件',
    phone: '手機號碼',
    department: '部門',
    position: '職位',
    joinDate: '入職日期',
    noMessages: '暫無訊息',
    allRead: '全部已讀',
    unread: '未讀',
    read: '已讀',
  },

  // 系統管理
  system: {
    title: '系統管理',
    // 使用者管理
    user: {
      title: '使用者管理',
      username: '使用者名稱',
      realName: '真實姓名',
      nickname: '暱稱',
      email: '電子郵件',
      phone: '手機號碼',
      avatar: '頭像',
      status: '狀態',
      role: '角色',
      department: '部門',
      position: '職位',
      createUser: '新增使用者',
      editUser: '編輯使用者',
      deleteUser: '刪除使用者',
      resetPassword: '重設密碼',
      assignRole: '分配角色',
    },
    // 角色管理
    role: {
      title: '角色管理',
      roleName: '角色名稱',
      roleCode: '角色編碼',
      description: '描述',
      status: '狀態',
      createRole: '新增角色',
      editRole: '編輯角色',
      deleteRole: '刪除角色',
      assignPermission: '分配權限',
    },
    // 組織管理
    org: {
      title: '組織管理',
      orgName: '組織名稱',
      orgCode: '組織編碼',
      parentOrg: '上級組織',
      leader: '負責人',
      phone: '聯絡電話',
      email: '電子郵件',
      address: '地址',
      sort: '排序',
      createOrg: '新增組織',
      editOrg: '編輯組織',
      deleteOrg: '刪除組織',
    },
    // 選單管理
    menu: {
      title: '選單管理',
      menuName: '選單名稱',
      menuType: '選單類型',
      icon: '圖示',
      path: '路徑',
      component: '元件',
      permission: '權限標識',
      sort: '排序',
      visible: '是否可見',
      directory: '目錄',
      menuItem: '選單',
      button: '按鈕',
      createMenu: '新增選單',
      editMenu: '編輯選單',
      deleteMenu: '刪除選單',
    },
    // 字典管理
    dict: {
      title: '字典管理',
      dictName: '字典名稱',
      dictCode: '字典編碼',
      dictValue: '字典值',
      createDict: '新增字典',
      editDict: '編輯字典',
      deleteDict: '刪除字典',
    },
    // 日誌管理
    log: {
      title: '操作日誌',
      operator: '操作人',
      operateType: '操作類型',
      operateTime: '操作時間',
      ip: 'IP地址',
      browser: '瀏覽器',
      os: '作業系統',
      result: '操作結果',
      detail: '詳情',
    },
  },

  // 組織管理
  organization: {
    // 組織切換器
    selectOrg: '選擇組織',
    switchSuccess: '已切換到 {{name}}',
    switchFailed: '切換組織失敗',
    primary: '主組織',
    current: '目前',
    loadFailed: '載入組織列表失敗',
    selectRequired: '請選擇一個組織',
    selectTitle: '選擇工作組織',
    selectHint: '請選擇您要工作的組織',

    // 頁面標題
    title: '組織架構管理',
    description: '管理租戶內的組織架構',
    treeView: '列表',
    chartView: '結構圖',
    chartViewComingSoon: '組織結構圖視圖即將推出',

    // 基本欄位
    name: '組織名稱',
    shortName: '簡稱',
    code: '組織編碼',
    status: '狀態',
    level: '層級',
    path: '路徑',
    sortOrder: '排序',
    root: '根組織',
    childrenCount: '下級數',

    // 操作
    add: '新增組織',
    edit: '編輯組織',
    detail: '組織詳情',
    addChild: '新增下級',
    deleteConfirm: '確認刪除',
    deleteHint: '確定要刪除組織「{{name}}」嗎？',
    deleteWithChildren: '該組織存在下級組織，請先刪除下級組織。',
    deleteSuccess: '刪除成功',
    deleteFailed: '刪除失敗',
    createSuccess: '建立成功',
    createFailed: '建立失敗',
    updateSuccess: '更新成功',
    updateFailed: '更新失敗',
    loadDetailFailed: '載入詳情失敗',

    // 表單
    parentOrg: '上級組織',
    basicInfo: '基本資訊',
    contactInfo: '聯絡資訊',
    addressInfo: '地址資訊',
    businessInfo: '企業資訊',
    validityPeriod: '有效期',
    systemInfo: '系統資訊',

    // 表單欄位
    namePlaceholder: '請輸入組織名稱',
    nameRequired: '請輸入組織名稱',
    shortNamePlaceholder: '請輸入簡稱',
    codePlaceholder: '請輸入組織編碼',
    codeRequired: '請輸入組織編碼',
    codePattern: '只能包含字母、數字、-和_',
    relationTypeLabel: '關係類型',
    relationTypePlaceholder: '請選擇關係類型',
    relationTypeRequired: '請選擇關係類型',

    // 聯絡資訊
    contactName: '聯絡人',
    contactNamePlaceholder: '請輸入聯絡人姓名',
    contactPhone: '聯絡電話',
    contactPhonePlaceholder: '請輸入電話號碼',
    contactEmail: '電子郵件',
    contactEmailPlaceholder: '請輸入電子郵件',
    emailInvalid: '電子郵件格式不正確',

    // 地址資訊
    province: '省份',
    provincePlaceholder: '省份',
    city: '城市',
    cityPlaceholder: '城市',
    district: '區/縣',
    districtPlaceholder: '區/縣',
    region: '地區',
    address: '詳細地址',
    addressPlaceholder: '請輸入詳細地址',

    // 企業資訊
    creditCode: '統一編號',
    creditCodePlaceholder: '請輸入統一編號',
    legalPerson: '法人代表',
    legalPersonPlaceholder: '請輸入法人代表',
    bankName: '開戶銀行',
    bankNamePlaceholder: '請輸入開戶銀行',
    bankAccount: '銀行帳號',
    bankAccountPlaceholder: '請輸入銀行帳號',
    validFrom: '生效日期',
    validTo: '失效日期',
    remark: '備註',
    remarkPlaceholder: '請輸入備註',
    noData: '暫無資料',

    // 篩選
    searchPlaceholder: '搜尋名稱或編碼',
    filterByType: '按類型篩選',
    filterByStatus: '按狀態篩選',

    // 成員管理
    members: '成員管理',
    member: '成員',
    memberRole: '角色',
    addMember: '新增成員',
    removeMemberConfirm: '確定移除該成員？',
    loadMembersFailed: '載入成員列表失敗',
    addMemberSuccess: '新增成員成功',
    addMemberFailed: '新增成員失敗',
    removeMemberSuccess: '移除成員成功',
    removeMemberFailed: '移除成員失敗',
    noMembers: '該組織暫無成員',
    selectUser: '選擇用戶',
    selectUserRequired: '請選擇用戶',
    searchUserPlaceholder: '搜尋姓名或用戶名',
    noUsersFound: '未找到用戶',
    setPrimary: '設為主組織',
    primaryOrg: '主組織',
    role: {
      admin: '管理員',
      manager: '經理',
      member: '成員',
      viewer: '訪客',
    },

    // 組織操作
    move: '遷移',
    moveSuccess: '組織遷移成功',
    moveFailed: '組織遷移失敗',
    moveWarning: '遷移組織將同時移動其所有子組織',
    currentOrg: '當前組織',
    newParent: '新的上級組織',
    selectNewParent: '請選擇新的上級組織',
    selectParent: '選擇上級組織',
    rootLevel: '根級別',

    merge: '合併',
    mergeSuccess: '組織合併成功',
    mergeFailed: '組織合併失敗',
    mergeWarning: '合併後來源組織將被刪除，所有子組織將移動到目標組織下',
    sourceOrg: '來源組織',
    targetOrg: '目標組織',
    selectBelow: '請在下方選擇',
    targetOrganization: '目標組織',
    selectTarget: '請選擇目標組織',
    selectTargetOrg: '選擇目標組織',
    mergeUsers: '遷移用戶',
    mergeUsersHint: '如果啟用，來源組織的所有用戶將被移動到目標組織',

    split: '拆分',
    splitSuccess: '組織拆分成功',
    splitFailed: '組織拆分失敗',
    splitHint: '從選定組織中拆分出新組織，可以選擇性地遷移子組織和用戶',
    newOrgName: '新組織名稱',
    newOrgCode: '新組織編碼',
    sameParent: '與來源組織同級',
    sameParentHint: '如果啟用，新組織將與來源組織同級；否則新組織將作為來源組織的子組織',
    moveChildren: '遷移子組織',
    moveUsers: '遷移用戶',
    keepInSource: '保留在來源組織',
    moveToNew: '遷移到新組織',
    noChildren: '沒有子組織',
    noUsers: '該組織暫無用戶',

    // 關係類型
    relationType: {
      headquarters: '總部',
      subsidiary: '子公司',
      branch: '分公司',
      division: '事業部',
      region: '區域',
      store: '門市',
      direct_store: '直營店',
      franchise: '加盟店',
      dealer: '經銷商',
      distributor: '分銷商',
      agent: '代理商',
      ecommerce: '電商通路',
      supplier: '供應商',
      manufacturer: '製造商',
      logistics: '物流商',
      warehouse: '倉庫',
      customer: '客戶',
      partner: '合作夥伴',
    },
  },

  // 版本更新記錄
  changelog: {
    title: '版本更新記錄',
    version: '版本',
    buildTime: '建置時間',
    clickToView: '點擊查看更新記錄',
    loadError: '載入更新記錄失敗',
    noData: '暫無更新記錄',
    type: {
      feature: '新功能',
      fix: '問題修復',
      improvement: '優化改進',
      breaking: '重大變更',
    },
  },

  // AI 助手
  aiChat: {
    title: 'AI 助手',
  },
};
